/* ==========================================================================
   Dr. Glowed — comportamenti di conversione
   1. upsell "completa il rituale" sulla scheda prodotto
   2. upsell dentro il carrello
   3. barra di acquisto fissa su mobile
   Nessuna dipendenza esterna. Se qualcosa non c'è, lo script non fa niente.
   ========================================================================== */
(function () {
  'use strict';

  var money = function (cents) {
    var value = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return value + ' AED';
  };

  /* ---------- carrello: aggiorna il cassetto senza ricaricare ---------- */
  function refreshCart() {
    return fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var parser = new DOMParser();

        var drawer = document.querySelector('cart-drawer');
        if (drawer && data['cart-drawer']) {
          var freshDoc = parser.parseFromString(data['cart-drawer'], 'text/html');
          var fresh = freshDoc.querySelector('cart-drawer');
          if (fresh) {
            drawer.innerHTML = fresh.innerHTML;
            drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
          }
          if (typeof drawer.open === 'function') drawer.open();
        }

        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data['cart-icon-bubble']) {
          var bDoc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
          var bFresh = bDoc.getElementById('cart-icon-bubble');
          if (bFresh) bubble.innerHTML = bFresh.innerHTML;
        }

        // niente cassetto: il tema usa la pagina carrello
        if (!drawer) goToCart();
      });
  }

  /* Perche' non si va al carrello subito.

     Il ROLLER in regalo del primo ordine non lo mette Appstle sul server: lo
     mette il suo widget nel browser, che guarda il carrello, trova la riga con
     l'abbonamento e fa una seconda aggiunta. Parte circa cento millisecondi
     dopo la nostra. Se nel frattempo abbiamo gia' cambiato pagina, quella
     aggiunta muore a meta' e il cliente paga l'abbonamento senza ricevere il
     roller, senza che nessuno se ne accorga.

     Quindi: se nel carrello c'e' una riga in abbonamento, si aspetta che il
     numero di righe smetta di crescere, al massimo un secondo e mezzo. Se non
     c'e' nessun abbonamento si va via subito, come prima. */
  function goToCart() {
    var url = window.Shopify.routes.root + 'cart';
    var deadline = Date.now() + 1500;

    function look(previous) {
      fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var hasPlan = (cart.items || []).some(function (i) {
            return i.selling_plan_allocation;
          });
          var count = (cart.items || []).length;
          if (!hasPlan || count > previous || Date.now() > deadline) {
            window.location.href = url;
            return;
          }
          setTimeout(function () { look(previous); }, 200);
        })
        .catch(function () { window.location.href = url; });
    }

    look(0);
  }

  function addToCart(items, button) {
    if (!items.length) return Promise.resolve();
    var original = button ? button.textContent : null;
    if (button) {
      button.setAttribute('disabled', 'disabled');
      button.textContent = 'Adding…';
    }
    /* Qui NON si usa fetch. L'app abbonamenti avvolge window.fetch e, quando la
       sua interfaccia e' nascosta, riscrive la richiesta togliendo il
       selling_plan: la riga entra come acquisto singolo a prezzo pieno e nessuno
       se ne accorge. Verificato il 1 set 2026: stesso corpo, /cart/add.js via
       fetch torna 649 senza piano, via XHR torna 479 col piano e col ROLLER in
       regalo. XMLHttpRequest non passa da quel wrapper. */
    return new Promise(function (risolvi, rifiuta) {
      var x = new XMLHttpRequest();
      x.open('POST', window.Shopify.routes.root + 'cart/add.js', true);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('Accept', 'application/json');
      x.onload = function () {
        if (x.status >= 200 && x.status < 300) risolvi();
        else rifiuta(new Error('add failed ' + x.status));
      };
      x.onerror = function () { rifiuta(new Error('add failed')); };
      x.send(JSON.stringify({ items: items }));
    })
      .then(function () {
        return refreshCart();
      })
      .catch(function () {
        window.location.href = window.Shopify.routes.root + 'cart';
      })
      .then(function () {
        if (button) {
          button.removeAttribute('disabled');
          if (original) button.textContent = original;
        }
      });
  }

  /* ---------- 1. upsell scheda prodotto ---------- */
  function initRoutine(root) {
    var boxes = root.querySelectorAll('[data-dg-up-item]');
    var totalEl = root.querySelector('[data-dg-up-total]');
    var addBtn = root.querySelector('[data-dg-up-add]');
    if (!boxes.length || !addBtn) return;

    function recalc() {
      var total = 0;
      var count = 0;
      boxes.forEach(function (b) {
        if (b.checked) {
          total += parseInt(b.getAttribute('data-price'), 10) || 0;
          count += 1;
        }
      });
      if (totalEl) totalEl.textContent = count ? money(total) : '—';
      addBtn.disabled = count === 0;
      addBtn.textContent = count > 1 ? 'Add all ' + count : 'Add to cart';
    }

    boxes.forEach(function (b) {
      b.addEventListener('change', recalc);
    });

    addBtn.addEventListener('click', function () {
      var items = [];
      boxes.forEach(function (b) {
        if (b.checked) items.push({ id: parseInt(b.value, 10), quantity: 1 });
      });
      addToCart(items, addBtn);
    });

    recalc();
  }

  /* ---------- 2. upsell dentro il carrello ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-dg-cart-add]') : null;
    if (!btn) return;
    e.preventDefault();
    var id = parseInt(btn.getAttribute('data-variant'), 10);
    var q = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    if (!id) return;
    var line = { id: id, quantity: q };
    // i richiami in fondo alla pagina devono aggiungere la stessa cosa che è
    // selezionata nel buy box, altrimenti si compra un abbonamento dall'alto e
    // un acquisto singolo dal basso senza accorgersene
    if (btn.hasAttribute('data-dg-use-plan')) {
      var chosen = document.querySelector('[data-dg-sub] [data-dg-sub-o].is-on');
      var plan = chosen && chosen.getAttribute('data-plan');
      if (plan) line.selling_plan = parseInt(plan, 10);
    }
    addToCart([line], btn);
  });

  /* La barra fissa, sulle pagine che hanno un abbonamento, vende sempre
     l'abbonamento e lo dichiara. In quel caso il prezzo in barra non deve piu'
     seguire la scheda selezionata, altrimenti direbbe una cosa e ne farebbe
     un'altra. */
  function barraSuAbbonamento() {
    var bar = document.querySelector('[data-dg-sticky]');
    return !!(bar && bar.hasAttribute('data-dg-sticky-sub'));
  }

  /* Il prezzo del tema ha due blocchi, uno col prezzo pieno e uno con quello
     scontato, e ne mostra uno solo a seconda della classe price--on-sale.
     querySelector con la virgola torna il primo nel documento, non quello che
     si vede: appena una variante prende un prezzo barrato si finiva a scrivere
     nel blocco nascosto, e in pagina restava la cifra vecchia. */
  function prezzoTema() {
    var blocco = document.querySelector('.product__info-container .price') ||
      document.querySelector('.price');
    if (!blocco) return null;
    return blocco.querySelector(
      blocco.classList.contains('price--on-sale')
        ? '.price__sale .price-item--sale'
        : '.price__regular .price-item--regular'
    );
  }

  function scriviPrezzoBarra(text) {
    if (barraSuAbbonamento()) return null;
    var sticky = document.querySelector('[data-dg-sticky] .dg-sticky__p');
    if (sticky && text) sticky.textContent = text;
    return sticky;
  }

  /* ---------- 2b. il cassetto del menu si aggancia sotto l'intestazione ----
     Il tema mette il cassetto in absolute sotto un'intestazione che non e'
     fissa: aperto dopo uno scroll nasceva a meta' pagina. In fixed va bene,
     ma "sopra a tutto" nasconde logo e X. Qui si misura dove finisce
     l'intestazione e si passa la quota al CSS, cosi' il cassetto parte
     esattamente sotto e arriva al fondo dello schermo, senza scrollare. */
  function ancoraMenu() {
    if (window.__dgMenuAncorato) return;
    window.__dgMenuAncorato = true;
    /* Il gruppo intestazione e' fatto di piu' sezioni (barra annunci + testata):
       querySelector prendeva la prima, cioe' la barra annunci, e il cassetto
       partiva a 39px coprendo logo e X. Serve la piu' bassa di tutte. */
    var pezzi = document.querySelectorAll(
      '.shopify-section-group-header-group, .section-header, .header-wrapper'
    );
    if (!pezzi.length) return;
    function misura() {
      var quota = 0;
      for (var i = 0; i < pezzi.length; i++) {
        var b = pezzi[i].getBoundingClientRect();
        if (b.height > 0 && b.bottom > quota) quota = b.bottom;
      }
      quota = Math.max(0, Math.round(quota));
      document.documentElement.style.setProperty('--dg-header-bottom', quota + 'px');
    }
    misura();
    window.addEventListener('resize', misura, { passive: true });
    window.addEventListener('scroll', misura, { passive: true });
    // il menu si apre con un <details>: alla prima apertura l'intestazione
    // puo' essersi mossa, quindi si rimisura subito dopo il clic
    document.addEventListener(
      'click',
      function (e) {
        if (e.target && e.target.closest && e.target.closest('.header__icon--menu')) {
          misura();
          setTimeout(misura, 60);
        }
      },
      true
    );
  }

  /* ---------- 3. barra di acquisto fissa su mobile ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-dg-sticky]');
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    if (!bar || !form) return;

    var realButton = form.querySelector('[type="submit"]');
    if (!realButton) return;

    // .product__info-wrapper ha un transform: un elemento fixed dentro un
    // contenitore trasformato si ancora al contenitore, non allo schermo.
    // Spostandolo in fondo al body torna a comportarsi come deve.
    if (bar.parentElement !== document.body) document.body.appendChild(bar);

    var stickyButton = bar.querySelector('[data-dg-sticky-add]');

    /* Se la pagina ha un'opzione in abbonamento disponibile, la barra vende
       quella e basta: prezzo dell'abbonamento, cadenza scritta sotto, bottone
       "Subscribe". Chi vuole il 6 o il 12 settimane usa il bottone dentro la
       pagina. Al clic la scheda dell'abbonamento viene selezionata davvero,
       cosi' quello che il cliente vede e quello che finisce nel carrello
       restano la stessa cosa. */
    var optAbbo = null;
    var candidati = bar.ownerDocument.querySelectorAll('[data-dg-offer-o][data-plan]');
    for (var i = 0; i < candidati.length; i++) {
      var piano = candidati[i].getAttribute('data-plan');
      if (piano && !candidati[i].classList.contains('dg-offer__o--out')) {
        optAbbo = candidati[i];
        break;
      }
    }

    if (optAbbo) {
      bar.setAttribute('data-dg-sticky-sub', '');

      var prezzoAbbo = optAbbo.querySelector('.dg-offer__p');
      var campoPrezzo = bar.querySelector('.dg-sticky__p');
      if (prezzoAbbo && campoPrezzo) campoPrezzo.textContent = prezzoAbbo.textContent.trim();

      // basta la cadenza: che sia un abbonamento lo dice gia' il bottone
      var meta =
        optAbbo.querySelector('.dg-offer__weeks') ||
        optAbbo.querySelector('.dg-offer__meta');
      var nota = bar.querySelector('.dg-sticky__x');
      if (!nota) {
        nota = document.createElement('div');
        nota.className = 'dg-sticky__x';
        var colonna = bar.querySelector('.dg-sticky__c');
        if (colonna) colonna.appendChild(nota);
      }
      nota.textContent = meta
        ? meta.textContent.replace(/\s+/g, ' ').trim()
        : 'Subscription';

      if (stickyButton) stickyButton.textContent = 'Subscribe';
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        /* Non si passa dal form. Il form porta il selling_plan fino a Shopify
           ma l'abbonamento non veniva applicato lo stesso, mentre
           /cart/add.js con lo stesso piano lo applica sempre. Quindi la barra
           aggiunge da se', e la scheda in pagina si allinea a quello che ha
           appena messo nel carrello. */
        if (optAbbo) {
          var variante = parseInt(optAbbo.getAttribute('data-variant'), 10);
          var piano = parseInt(optAbbo.getAttribute('data-plan'), 10);
          var quanti = parseInt(optAbbo.getAttribute('data-qty'), 10) || 1;
          if (variante && piano) {
            if (!optAbbo.classList.contains('is-on')) optAbbo.click();
            addToCart([{ id: variante, quantity: quanti, selling_plan: piano }], stickyButton);
            return;
          }
        }
        realButton.click();
      });
    }

    document.body.classList.add('dg-has-sticky');

    // stessa scelta dei reel: si guarda la posizione allo scroll, senza observer
    var pending = false;
    function check() {
      pending = false;
      var r = realButton.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var gone = r.bottom < 60 || r.top > vh - 20;
      bar.classList.toggle('is-on', gone);
    }
    function ask() {
      if (pending) return;
      pending = true;
      setTimeout(check, 90);
    }
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask, { passive: true });
    ask();
  }

  /* ---------- 4. scelta della confezione ---------- */
  function initPacks() {
    var wrap = document.querySelector('[data-dg-packs]');
    if (!wrap) return;

    // la quantità del tema diventa inutile: la scelta della confezione È la quantità
    document.body.classList.add('dg-has-packs');

    var qty = document.querySelector('.product-form__quantity .quantity__input, .quantity__input');

    wrap.querySelectorAll('[data-dg-pack]').forEach(function (pack) {
      if (pack.dataset.dgBound) return;
      pack.dataset.dgBound = '1';
      pack.addEventListener('click', function () {
        wrap.querySelectorAll('[data-dg-pack]').forEach(function (o) {
          o.classList.toggle('is-on', o === pack);
        });
        applyPack(pack);
      });
    });

    /* Applica la confezione scelta: quantita', piano di abbonamento e prezzo
       mostrato. Sta in una funzione sua perche' serve anche all'avvio, per non
       lasciare la pagina in uno stato diverso da quello che si vede acceso. */
    function applyPack(pack) {
      var n = parseInt(pack.getAttribute('data-qty'), 10) || 1;
      if (qty) {
        qty.value = n;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /* Il piano va infilato nel form del tema. Un campo `selling_plan` vuoto
         fa fallire l'aggiunta al carrello, quindi quando non c'e' piano il
         campo si toglie invece di svuotarlo. */
      var form = document.querySelector('product-form form[action*="/cart/add"]');
      if (form) {
        var planId = pack.getAttribute('data-plan');
        var field = form.querySelector('input[name="selling_plan"]');
        if (planId) {
          if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.name = 'selling_plan';
            form.appendChild(field);
          }
          field.value = planId;
        } else if (field) {
          field.remove();
        }
      }

      /* Il prezzo grande deve dire quanto si paga davvero per la confezione
         scelta, non il prezzo di un pezzo. Si copia gia' formattato, cosi' la
         valuta resta quella del negozio. */
      var tag = pack.querySelector('.dg-pack__p .now');
      if (tag) {
        var big = prezzoTema();
        if (big) big.textContent = tag.textContent.trim();
        var wasEl = pack.querySelector('.dg-pack__p .was');
        var oldPrice = document.querySelector('.price__sale .price-item--regular');
        if (oldPrice) {
          oldPrice.textContent = wasEl ? wasEl.textContent.trim() : '';
          oldPrice.style.display = wasEl ? '' : 'none';
        }
      }

      var sticky = scriviPrezzoBarra(tag ? tag.textContent.trim() : '');
      if (sticky) sticky.dataset.qty = n;
    }

    applyPack(wrap.querySelector('[data-dg-pack].is-on') || wrap.querySelector('[data-dg-pack]'));
  }


  /* ---------- 5. abbonamento o acquisto singolo ----------
     Il piano scelto va infilato nel form del tema come campo `selling_plan`:
     è quello che Shopify legge per creare un contratto invece di un ordine
     secco. Se si sceglie l'acquisto singolo il campo va TOLTO, non svuotato,
     perché un `selling_plan` vuoto fa fallire l'aggiunta al carrello. */
  function initSubscribe() {
    var wrap = document.querySelector('[data-dg-sub]');
    if (!wrap) return;
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    if (!form) return;

    var opts = [].slice.call(wrap.querySelectorAll('[data-dg-sub-o]'));
    if (!opts.length) return;

    function hiddenField() {
      return form.querySelector('input[name="selling_plan"]');
    }

    function apply(opt) {
      opts.forEach(function (o) {
        o.classList.toggle('is-on', o === opt);
        var radio = o.querySelector('input[type="radio"]');
        if (radio) radio.checked = o === opt;
      });

      var plan = opt.getAttribute('data-plan');
      var field = hiddenField();
      if (plan) {
        if (!field) {
          field = document.createElement('input');
          field.type = 'hidden';
          field.name = 'selling_plan';
          form.appendChild(field);
        }
        field.value = plan;
      } else if (field) {
        field.remove();
      }

      // il prezzo grande in cima deve dire quello che si paga davvero.
      // Si copia la stringa già formattata dall'opzione invece di riformattarla
      // qui: così la valuta resta quella del negozio senza doverla indovinare.
      var label = opt.querySelector('.dg-sub__p b');
      if (!label) return;
      var text = label.textContent.trim();
      var big = prezzoTema();
      if (big) big.textContent = text;
      scriviPrezzoBarra(text);
    }

    opts.forEach(function (opt) {
      if (opt.dataset.dgBound) return;
      opt.dataset.dgBound = '1';
      opt.addEventListener('click', function () {
        apply(opt);
      });
    });

    var start = wrap.querySelector('[data-dg-sub-o].is-on') || opts[0];
    apply(start);
  }


  /* ---------- 6. le tre opzioni dell'offerta ----------
     Una scelta sola in tutta la pagina. Ogni opzione porta la sua variante e,
     quando esisterà, il suo piano di abbonamento: il campo `selling_plan` va
     AGGIUNTO al form quando serve e RIMOSSO quando non serve, perché un
     `selling_plan` vuoto fa fallire l'aggiunta al carrello. */
  /* Rete di sicurezza sull'invio del form.

     Il tema ridisegna il blocco del prodotto quando cambia la variante, e in
     quel ridisegno il campo `selling_plan` torna al valore che gli da' Liquid,
     cioe' vuoto. Il risultato era che chi apriva la pagina e premeva subito
     "Add to cart", senza toccare le opzioni, comprava l'acquisto singolo da
     649 invece dell'abbonamento da 479 che vedeva selezionato.

     Qui il piano viene riscritto un istante prima che il tema costruisca il
     FormData. E' agganciato a `document` in fase di cattura, quindi gira
     sempre prima del gestore del tema e nessun ridisegno puo' piu' annullarlo. */

  /* Ultima rete: anche chiamando /cart/change.js a mano, una riga in
     abbonamento non puo' scendere sotto la quantita' con cui e' entrata.
     Lo stepper e' gia' tolto dal markup, questo copre il resto. */
  function proteggiAbbonamenti() {
    if (window.__dgQtyGuard) return;
    window.__dgQtyGuard = true;
    var vero = window.fetch;
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/change/.test(url) && init && init.body) {
          var corpo = typeof init.body === 'string' ? JSON.parse(init.body) : null;
          if (corpo && corpo.quantity !== undefined && Number(corpo.quantity) > 0) {
            return vero('/cart.js', { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                var riga = corpo.line ? cart.items[corpo.line - 1] : null;
                if (riga && riga.selling_plan_allocation && Number(corpo.quantity) < riga.quantity) {
                  return new Response(JSON.stringify(cart), {
                    status: 200, headers: { 'Content-Type': 'application/json' }
                  });
                }
                return vero(input, init);
              })
              .catch(function () { return vero(input, init); });
          }
        }
      } catch (e) {}
      return vero(input, init);
    };
  }

  function armaInvio() {
    if (window.__dgSubmitArmed) return;
    window.__dgSubmitArmed = true;

    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

        /* La barra fissa impone la sua scelta con __dgScelta: il tema
           rigenera la sezione quando cambia variante, e fra il clic sulla
           scheda e l'invio la classe is-on puo' essere ancora quella vecchia.
           Chiedere al DOM in quel momento vuol dire aggiungere l'opzione
           sbagliata. */
        var scelta =
          window.__dgScelta ||
          document.querySelector('[data-dg-offer-o].is-on') ||
          document.querySelector('[data-dg-pack].is-on');
        window.__dgScelta = null;
        if (!scelta) return;

        var variant = scelta.getAttribute('data-variant');
        var plan = scelta.getAttribute('data-plan');
        var qta = scelta.getAttribute('data-qty');

        function campo(nome) {
          var el = form.querySelector('[name="' + nome + '"]');
          if (!el) {
            el = document.createElement('input');
            el.type = 'hidden';
            el.name = nome;
            form.appendChild(el);
          }
          return el;
        }

        /* Con un piano di mezzo non ci si puo' fidare dell'invio del tema, che
           passa da fetch: si ferma il form e si aggiunge da qui, via XHR. */
        if (plan && variant) {
          e.preventDefault();
          e.stopPropagation();
          addToCart(
            [{
              id: parseInt(variant, 10),
              quantity: parseInt(qta, 10) || 1,
              selling_plan: parseInt(plan, 10)
            }],
            form.querySelector('[type="submit"]')
          );
          return;
        }

        if (variant) campo('id').value = variant;
        if (qta) campo('quantity').value = qta;

        var pf = form.querySelector('[name="selling_plan"]');
        if (plan) {
          campo('selling_plan').value = plan;
        } else if (pf) {
          pf.remove();   // un selling_plan vuoto fa fallire l'aggiunta
        }
      },
      true
    );
  }

  /* La galleria segue l'opzione scelta.

     Le 4 e le 8 settimane sono due varianti e hanno la loro foto collegata su
     Shopify, ma l'abbonamento variante non ce l'ha: e' la variante delle 8
     settimane piu' il piano. Shopify da solo non puo' quindi distinguerlo, e
     chi sceglie Subscription vedrebbe la foto delle 8 settimane. Percio' la
     galleria la muoviamo noi, una foto per opzione.

     Non chiamo setActiveMedia del tema apposta: quello, se la galleria e'
     sopra la finestra, riporta la pagina in cima. Sul telefono il buy box sta
     sotto le foto, quindi ogni tocco su una opzione farebbe risalire la
     pagina. Qui si fa lo stesso lavoro (foto attiva, miniatura attiva, la
     scelta portata davanti) senza toccare lo scorrimento della pagina. */
  function mostraMedia(media) {
    if (!media) return;
    var g = document.querySelector('media-gallery');
    if (!g) return;
    var sezione = (g.id || '').replace('MediaGallery-', '');
    var chiave = sezione ? sezione + '-' + media : String(media);

    var visore = g.querySelector('[id^="GalleryViewer"]');
    if (!visore) return;
    var voce = visore.querySelector('[data-media-id="' + chiave + '"]');
    if (!voce) return;

    visore.querySelectorAll('[data-media-id]').forEach(function (n) {
      n.classList.remove('is-active');
    });
    voce.classList.add('is-active');

    var lista = voce.parentElement;
    if (lista && lista.firstChild !== voce) lista.prepend(voce);
    if (visore.slider && typeof visore.resetPages === 'function') visore.resetPages();
    /* La lista ha scroll-behavior: smooth, quindi uno scrollTo qui partirebbe
       come animazione e al caricamento della pagina si perde per strada: la
       foto giusta risultava prima nella lista ma il telefono mostrava ancora
       quella accanto. Si spegne l'animazione per un istante e si sposta di
       netto. */
    if (lista) {
      var andatura = lista.style.scrollBehavior;
      lista.style.scrollBehavior = 'auto';
      lista.scrollLeft = 0;
      lista.style.scrollBehavior = andatura;
    }

    /* Sul telefono le miniature visibili sono le prime quattro: portando
       davanti anche quella scelta si resta sicuri che si veda qual e' attiva. */
    var mini = g.querySelector('[id^="GalleryThumbnails"]');
    if (!mini) return;
    var t = mini.querySelector('[data-target="' + chiave + '"]');
    if (!t) return;
    mini.querySelectorAll('button').forEach(function (b) {
      b.removeAttribute('aria-current');
    });
    var b = t.querySelector('button');
    if (b) b.setAttribute('aria-current', 'true');
    if (t.parentElement && t.parentElement.firstChild !== t) t.parentElement.prepend(t);
  }

  /* Il prezzo grande in cima non e' piu' quello del tema.

     Quello del tema conosce solo la variante, e qui la variante non basta:
     l'abbonamento e' la variante delle 8 settimane piu' il piano, quindi
     Shopify gli attaccava 689 col barrato di quella. Il risultato, appena le
     varianti hanno preso un prezzo barrato, era "689 barrato, 689, SALE" con
     l'abbonamento selezionato a 479.

     Ora il blocco lo rende dg-offer con part: 'price', dagli stessi conti che
     fanno le tre opzioni, e qui si limita a seguirle. Un conto solo, quindi la
     cifra in cima e quella dell'opzione scelta non possono divergere. */
  function scriviPrezzo(opt) {
    var box = document.querySelector('[data-dg-price]');
    if (!box) return;

    function metti(chiave, testo) {
      var el = box.querySelector('[data-dg-price-' + chiave + ']');
      if (!el) return;
      el.textContent = testo;
      el.hidden = !testo;
    }

    var p = opt.querySelector('.dg-offer__p');
    var ora = p ? p.textContent.trim() : '';
    if (ora) metti('now', ora);

    metti('cycle', opt.getAttribute('data-cycle') || '');
    metti('was', opt.getAttribute('data-anchor') || '');

    var quanto = opt.getAttribute('data-save') || '';
    metti('save', quanto ? 'You save ' + quanto : '');

    var pct = parseInt(opt.getAttribute('data-pct'), 10);
    metti('note', pct > 0 ? pct + '% less than buying everything separately' : '');
  }

  function initOffer() {
    var wrap = document.querySelector('[data-dg-offer]');
    if (!wrap) return;
    var form = document.querySelector('product-form form[action*="/cart/add"]');
    if (!form) return;

    var opts = [].slice.call(wrap.querySelectorAll('[data-dg-offer-o]'));
    if (!opts.length) return;

    /* Il prezzo del tema lo spegne il CSS, agganciandolo come fratello del
       nostro. Se pero' qualcuno sposta i blocchi dall'editor quel selettore
       non aggancia piu' niente e in pagina comparirebbero due prezzi diversi.
       Rete di sicurezza: dove c'e' il nostro, quello del tema si spegne. */
    if (document.querySelector('[data-dg-price]')) {
      var temaPrezzo = document.querySelector('[id^="price-"] .price');
      if (temaPrezzo) temaPrezzo.style.display = 'none';
    }

    function apply(opt) {
      opts.forEach(function (o) {
        o.classList.toggle('is-on', o === opt);
        var radio = o.querySelector('input[type="radio"]');
        if (radio) radio.checked = o === opt;
      });

      var variant = opt.getAttribute('data-variant');
      var idField = form.querySelector('input[name="id"], select[name="id"]');
      if (idField && variant) idField.value = variant;

      var plan = opt.getAttribute('data-plan');
      var field = form.querySelector('input[name="selling_plan"]');
      if (plan) {
        if (!field) {
          field = document.createElement('input');
          field.type = 'hidden';
          field.name = 'selling_plan';
          form.appendChild(field);
        }
        field.value = plan;
      } else if (field) {
        field.remove();
      }

      mostraMedia(opt.getAttribute('data-media'));
      scriviPrezzo(opt);

      // la barra in basso prende la stessa stringa gia' formattata
      var tag = opt.querySelector('.dg-offer__p');
      if (tag && tag.textContent.trim()) scriviPrezzoBarra(tag.textContent.trim());
    }

    /* Un'opzione esaurita non si sceglie: il carrello la rifiuterebbe comunque,
       tanto vale non far arrivare nessuno fin li'. */
    function usable(o) {
      return o.getAttribute('data-available') !== 'false';
    }

    opts.forEach(function (opt) {
      if (opt.dataset.dgBound) return;
      opt.dataset.dgBound = '1';
      opt.addEventListener('click', function (e) {
        if (!usable(opt)) {
          e.preventDefault();
          return;
        }
        apply(opt);
      });
    });

    /* Le tre schede del programma sparse per il sito puntano tutte a questa
       pagina. Due dicono "One-time purchase" e finivano su una pagina gia'
       impostata sull'abbonamento: la promessa del link e quello che trovavi
       non coincidevano. Ora il link porta con se' ?option=4w, 12w o sub e la
       pagina si apre sulla scelta giusta. */
    var voluta = null;
    try {
      var q = new URLSearchParams(window.location.search).get('option');
      if (q) {
        var indice = { '4w': 0, '8w': 1, 'sub': 2 };
        if (indice[q] !== undefined) voluta = opts[indice[q]];
      }
    } catch (e) {}

    var start = voluta || wrap.querySelector('[data-dg-offer-o].is-on');
    if (!start || !usable(start)) {
      start = opts.filter(usable)[0] || opts[0];
    }
    apply(start);
  }

  function boot() {
    document.querySelectorAll('[data-dg-routine]').forEach(initRoutine);
    ancoraMenu();
    initSticky();
    initPacks();
    armaInvio();
    proteggiAbbonamenti();
    initSubscribe();
    initOffer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // il cassetto viene riscritto: rilego gli upsell che ci finiscono dentro
  document.addEventListener('shopify:section:load', boot);
})();
